import { useEffect, useMemo, useState } from 'react';
import ApisClient from '../utils/client/ApisClient';
import TokenHandlerClient from '../utils/client/TokenHandlerClient';

const useAxiosLoader = () => {
    const [counter, setCounter] = useState(0);

    const [hidden, setHidden] = useState(false);

    const requestHiddenLoader = ['/consumptions/detail', '/orders', '/bills/download?billId='];

    const interceptors = useMemo(() => {
        const isHiddenLoader = (url: string) => requestHiddenLoader.some((path) => url?.includes(path));

        const inc = (config: any) => {
            if (isHiddenLoader(config?.url)) return;
            // if (requestHiddenLoader.some((path: string) => (config?.url as string)?.includes(path))) setHidden(true);
            setCounter((counter) => counter + 1);
        };
        const dec = (response?: any) => {
            if (isHiddenLoader(response?.config?.url)) return;
            // if (requestHiddenLoader.some((path: string) => (response?.url as string)?.includes(path))) setHidden(true);
            setCounter((counter) => counter - 1);
        };

        return {
            request: (config: any) => (inc(config), config),
            response: (response: any) => (dec(response), response),
            error: (error: any) => (dec(), Promise.reject(error)),
        };
    }, []);

    useEffect(() => {
        const reqInterceptorClient = ApisClient.interceptors.request.use(interceptors.request, interceptors.error);
        const resInterceptorClient = ApisClient.interceptors.response.use(interceptors.response, interceptors.error);
        const reqInterceptorTokenHandler = TokenHandlerClient.interceptors.request.use(
            interceptors.request,
            interceptors.error,
        );
        const resInterceptorTokenHandler = TokenHandlerClient.interceptors.response.use(
            interceptors.response,
            interceptors.error,
        );

        return () => {
            ApisClient.interceptors.request.eject(reqInterceptorClient);
            ApisClient.interceptors.response.eject(resInterceptorClient);
            TokenHandlerClient.interceptors.request.eject(reqInterceptorTokenHandler);
            TokenHandlerClient.interceptors.response.eject(resInterceptorTokenHandler);
        };
    }, [interceptors]);

    return !hidden ? [counter > 0] : [];
};

export default useAxiosLoader;
